exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.model-card[data-v-70e61425]:hover {\n  text-decoration: none;\n}\n.card-text[data-v-70e61425] {\n  color: #676868;\n}\n.cursor-pointer[data-v-70e61425]{\n  cursor: pointer;\n}\n", ""]);

// exports
